import React from "react";
import { Coffee, Rocket } from "lucide-react";

/**
 * Visual marker distinguishing the two alert classes:
 *   • Steady   — Baseline strategy. 85% WR, +2.1% expectancy. The cup-of-coffee insurance.
 *   • Moonshot — Pre-Breakout Index. ~63% WR, but +13% best trade. The lottery ticket.
 */
export default function AlertClassBadge({ alertClass = "steady", compact = false }) {
  const isMoon = alertClass === "moonshot";
  if (compact) {
    return (
      <span
        className={`inline-flex items-center gap-1 rounded-full font-mono-data font-bold tracking-wider px-2 py-0.5 text-[10px] ${
          isMoon ? "bg-pink-100 text-pink-800" : "bg-emerald-100 text-emerald-800"
        }`}
        data-testid={`alert-class-badge-${alertClass}`}
      >
        {isMoon ? <Rocket className="w-2.5 h-2.5" /> : <Coffee className="w-2.5 h-2.5" />}
        {isMoon ? "MOONSHOT" : "STEADY"}
      </span>
    );
  }
  return (
    <span
      className={`inline-flex items-center gap-1.5 rounded-full font-mono-data font-bold tracking-wider px-2.5 py-1 text-[11px] ${
        isMoon ? "bg-gradient-to-r from-pink-500 to-pink-600 text-white" : "bg-mb-emerald text-white"
      }`}
      data-testid={`alert-class-badge-${alertClass}`}
    >
      {isMoon ? <Rocket className="w-3 h-3" /> : <Coffee className="w-3 h-3" />}
      {isMoon ? "MOONSHOT" : "STEADY"}
    </span>
  );
}
